"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalOverrideAdapter = void 0;
const client_core_1 = require("@statsig/client-core");
const LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
function _makeEmptyStore() {
    return {
        gate: {},
        dynamicConfig: {},
        experiment: {},
        layer: {},
    };
}
class LocalOverrideAdapter {
    constructor() {
        this._overrides = _makeEmptyStore();
    }
    overrideGate(name, value) {
        this._overrides.gate[name] = value;
        this._overrides.gate[(0, client_core_1._DJB2)(name)] = value;
    }
    removeGateOverride(name) {
        delete this._overrides.gate[name];
        delete this._overrides.gate[(0, client_core_1._DJB2)(name)];
    }
    getGateOverride(current, _user) {
        var _a;
        const overridden = (_a = this._overrides.gate[current.name]) !== null && _a !== void 0 ? _a : this._overrides.gate[(0, client_core_1._DJB2)(current.name)];
        if (overridden == null) {
            return null;
        }
        return Object.assign(Object.assign({}, current), { value: overridden, details: Object.assign(Object.assign({}, current.details), { reason: LOCAL_OVERRIDE_REASON }) });
    }
    overrideDynamicConfig(name, value) {
        this._overrides.dynamicConfig[name] = value;
        this._overrides.dynamicConfig[(0, client_core_1._DJB2)(name)] = value;
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.dynamicConfig[name];
        delete this._overrides.dynamicConfig[(0, client_core_1._DJB2)(name)];
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.dynamicConfig);
    }
    overrideExperiment(name, value) {
        this._overrides.experiment[name] = value;
        this._overrides.experiment[(0, client_core_1._DJB2)(name)] = value;
    }
    removeExperimentOverride(name) {
        delete this._overrides.experiment[name];
        delete this._overrides.experiment[(0, client_core_1._DJB2)(name)];
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.experiment);
    }
    overrideLayer(name, value) {
        this._overrides.layer[name] = value;
        this._overrides.layer[(0, client_core_1._DJB2)(name)] = value;
    }
    removeLayerOverride(name) {
        delete this._overrides.layer[name];
        delete this._overrides.layer[(0, client_core_1._DJB2)(name)];
    }
    getAllOverrides() {
        return JSON.parse(JSON.stringify(this._overrides));
    }
    removeAllOverrides() {
        this._overrides = _makeEmptyStore();
    }
    getLayerOverride(current, _user) {
        var _a;
        const overridden = (_a = this._overrides.layer[current.name]) !== null && _a !== void 0 ? _a : this._overrides.layer[(0, client_core_1._DJB2)(current.name)];
        if (overridden == null) {
            return null;
        }
        return Object.assign(Object.assign({}, current), { __value: overridden, get: (0, client_core_1._makeTypedGet)(current.name, overridden), details: Object.assign(Object.assign({}, current.details), { reason: LOCAL_OVERRIDE_REASON }) });
    }
    _getConfigOverride(current, lookup) {
        var _a;
        const overridden = (_a = lookup[current.name]) !== null && _a !== void 0 ? _a : lookup[(0, client_core_1._DJB2)(current.name)];
        if (overridden == null) {
            return null;
        }
        return Object.assign(Object.assign({}, current), { value: overridden, get: (0, client_core_1._makeTypedGet)(current.name, overridden), details: Object.assign(Object.assign({}, current.details), { reason: LOCAL_OVERRIDE_REASON }) });
    }
}
exports.LocalOverrideAdapter = LocalOverrideAdapter;
